import React,{useEffect} from 'react'
import Container from "./styles";


export default function Checkbox({ride, setBiker, biker}){


    return(
        <Container>
        <div className="bike_list">
        <svg
          width="39"
          height="39"
          viewBox="0 0 39 39"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="19.5"
            cy="19.5"
            r="19.5"
            fill="white"
            fill-opacity="0.8"
          />
          <circle
            cx="19.5"
            cy="19.5"
            r="19.1518"
            stroke="black"
            stroke-opacity="0.1"
            stroke-width="0.696429"
          />
          <path
            d="M25.9357 16.3803L25.1839 16.3436L23.8348 11.9768C23.6043 11.2395 22.9404 10.7201 22.1703 10.6825L19.7866 10.5661L19.6971 12.3997L22.0808 12.5161L23.2402 16.2487L18.8304 16.0333L18.5451 15.1004L19.5628 15.1501L19.6523 13.3165L15.0683 13.0926L14.9787 14.9262L16.5831 15.0046L18.0279 19.6701L17.4136 19.6401C17.1101 17.5759 15.4695 15.9795 13.3291 15.7739C10.7683 15.5202 8.4178 17.5466 8.29244 20.1137C8.16708 22.6808 10.0856 24.7962 12.6526 24.9216C14.908 25.0317 16.8081 23.5714 17.3241 21.4737L21.1747 21.6618C21.4782 23.726 23.1188 25.3224 25.2592 25.528C27.8204 25.7726 30.1705 23.7553 30.2963 21.179C30.4212 18.6211 28.5027 16.5056 25.9357 16.3803ZM15.4171 21.3806C14.998 22.4354 13.9615 23.1475 12.7422 23.088C11.2019 23.0128 10.0508 21.7435 10.1261 20.2032C10.2013 18.663 11.4706 17.5119 13.0108 17.5871C14.2301 17.6467 15.1923 18.4564 15.5067 19.547L12.9213 19.4207L12.8317 21.2544L15.4171 21.3806ZM21.2642 19.8282L19.9807 19.7655L19.401 17.8992L22.1789 18.0348C21.7495 18.5469 21.4261 19.1468 21.2642 19.8282ZM25.5775 23.7148C24.0373 23.6395 22.8862 22.3703 22.9614 20.83C23.003 19.9774 23.4147 19.2623 24.0261 18.7867L24.788 21.2501L26.5421 20.7108L25.7723 18.2195C25.7907 18.2204 25.8186 18.2126 25.8461 18.2139C27.3864 18.2891 28.5374 19.5584 28.4622 21.0986C28.387 22.6389 27.1177 23.79 25.5775 23.7148Z"
            fill="#FF7B0D"
          />
          <path
            d="M18.0191 27.9409L14.3519 27.7618L19.7184 30.7809L19.8079 28.9473L23.4752 29.1264L18.1086 26.1073L18.0191 27.9409Z"
            fill="#FF7B0D"
          />
        </svg>
        <div style={{ width: 200 }}>
          <div>{ride.bikerName}</div>
          <div className="bike_id">
            {ride.bikeId}{" "}
            <span style={{ color: "#fff" }}>Bike {ride.id}</span>
          </div>
        </div>
        <input
          type="radio"
          className="bike_checkbox"
          onClick={() => {
            setBiker({ ride });
          }}
          checked={biker.ride.id == ride.id? true:false}
        />
      </div>
      </Container>
    )
}